import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import DateInput from "components/Input/DateInput.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import styled from "styled-components";
import { workspaceText } from "variables/MBM/geb";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postGEBWorkspace, putGEBWorkspace } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSwitch from "components/Input/CustomSwitch.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import { getChartList } from "services/ConfigServices";



const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    // marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function WorkspaceDialog(props) {

  const { closeModal, refetch, setLoading, currentWorkspace } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);


  const { chartIdGroup } = advancedSearchContext;

  const [description, setDescription] = useState(currentWorkspace?.parameters.description || "");
  const [name, setName] = useState(currentWorkspace?.parameters.name || "");
  const [isdefault, setIsdefault] = useState(currentWorkspace?.parameters.isdefault || "");
  const [chart1, setChart1] = useState(currentWorkspace?.parameters.chart1 || "");
  const [chart2, setChart2] = useState(currentWorkspace?.parameters.chart2 || "");
  const [displayAutomationWidget, setDisplayAutomationWidget] = useState(currentWorkspace?.parameters.displayAutomationWidget || false);
  const [order2dplans, setOrder2dplans] = useState(currentWorkspace?.parameters.order2dplans || false);

  const [groups, setGroups] = useState(currentWorkspace?.idgroup ? "" + currentWorkspace.idgroup : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [chartsList, setChartsList] = useState([{ name: String, id: Number, version: String }]);

  const classes = useStyles();

  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleIsdefaultChange = (event) => { setIsdefault(!isdefault); };
  const handleDisplayAutomationWidgetChange = (event) => { setDisplayAutomationWidget(!displayAutomationWidget); };
  const handleOrder2dplansChange = (event) => { setOrder2dplans(!order2dplans); };

  const selectedChart1 = () => {
    let selected = chartsList.find((obj) => obj.chart == chart1.chart);
    if (!selected)
      selected = "";
    return selected;
  };
  const handleChart1Change = (selected) => { setChart1(selected || ""); };

  const selectedChart2 = () => {
    let selected = chartsList.find((obj) => obj.chart == chart2.chart);
    if (!selected)
      selected = "";
    return selected;
  };
  const handleChart2Change = (selected) => { setChart2(selected || ""); };


  useEffect(() => {
    axios
      .get(
        getChartList(groups),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        var existingchartstmp = [];
        for (var element in res.data) {
          existingchartstmp.push({
            chart: Number(element),
            name: res.data[element].name,
            type: res.data[element].type,
            granularity: res.data[element].granularity,
            version: res.data[element].version,
            period: 'oneweek',
          });
        }
        setChartsList(existingchartstmp);
      });
  }, [groups]);

  useEffect(() => {

  }, [chartsList]);

  const handleSubmit = (event) => {
    if (currentWorkspace)
      updateWorkspace(event);
    else
      createWorkspace(event);
  };

  useEffect(() => {
    if (!name || !groups || groups === '0')
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const createWorkspace = async (event) => {
    let newworkspace = {
      parameters: {
        name,
        description,
        isdefault,
        chart1,
        chart2,
        displayAutomationWidget,
        order2dplans,
      }
    }
    axios
      .post(
        postGEBWorkspace(groups),
        newworkspace
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Environnement créé");
          refetch(res.data.id);
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };

  const updateWorkspace = async (event) => {
    let newworkspaceparameters = {
      ...currentWorkspace.parameters,
      description,
      name,
      isdefault,
      chart1,
      chart2,
      displayAutomationWidget,
      order2dplans,
    }
    axios
      .put(
        putGEBWorkspace(currentWorkspace.id, groups),
        newworkspaceparameters
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Environnement modifié");
          refetch(currentWorkspace.id);
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={workspaceText.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                required
              />
            </div>
            <div>
              <TextInput
                inputTitle={workspaceText.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={workspaceText.isdefault}
                checkedState={isdefault}
                handleSwitchChange={handleIsdefaultChange}
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"} x
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={workspaceText.chart1}
                selected={selectedChart1()}
                list={chartsList}
                handleChange={(_, newValue) =>
                  handleChart1Change(newValue)
                }
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"} x
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={workspaceText.chart2}
                selected={selectedChart2()}
                list={chartsList}
                handleChange={(_, newValue) =>
                  handleChart2Change(newValue)
                }
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={workspaceText.displayAutomationWidget}
                checkedState={displayAutomationWidget}
                handleSwitchChange={handleDisplayAutomationWidgetChange}
              />
            </div>
             <div>
              <CustomSwitch
                inputTitle={workspaceText.order2dplans}
                checkedState={order2dplans}
                handleSwitchChange={handleOrder2dplansChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>{workspaceText.group}</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={"" + chartIdGroup[0]}
                  cantSelectZero={true}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default WorkspaceDialog;
